import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class QuestionCategoryService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;

  getQuestionCategory (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/questioncategory/question_category_all/' + param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('question_list', []))
      );
  }
  save (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/questioncategory/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveQ', []))
      );
  }
  set (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/questioncategory/set',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveQ', []))
      );
  }
  update (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/questioncategory/update',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateQ', []))
      );
  }
  delete (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/questioncategory/delete',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteEvent', []))
      );
  }
  copy (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/questioncategory/copy',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('copyEvent', []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/questioncategory.service.ts